var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4848",
    d: "M7.05273 13.7158C7.30566 13.7158 7.51074 13.5312 7.55176 13.2578C8.13965 8.70508 8.78223 8.05566 13.2324 7.56348C13.5127 7.53613 13.7109 7.33105 13.7109 7.06445C13.7109 6.79785 13.5127 6.59277 13.2324 6.55859C8.78223 6.07324 8.13965 5.42383 7.55176 0.864258C7.51074 0.59082 7.30566 0.413086 7.05273 0.413086C6.7998 0.413086 6.59473 0.59082 6.55371 0.864258C5.96582 5.42383 5.32324 6.07324 0.873047 6.55859C0.592773 6.59277 0.394531 6.79785 0.394531 7.06445C0.394531 7.33105 0.592773 7.53613 0.873047 7.56348C5.32324 8.15137 5.9248 8.71191 6.55371 13.2578C6.59473 13.5312 6.7998 13.7158 7.05273 13.7158Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShine);
export default __webpack_public_path__ + "static/media/shine.317b38298eba4b68553d70738517a6f7.svg";
export { ForwardRef as ReactComponent };